import ProvincePopup from './modules/province-popup';
import Forms from './modules/forms';
import Tabs from './modules/tabs';
import Burger from '../../includes/mlmi-elements/modules/burger';
import Mobile from '../../includes/mlmi-elements/modules/mobile';
import Carousel from './modules/carousel';
import Locator from './modules/locator';
import Filters from './modules/filters';
import Cart from './modules/cart';
import PlanForm from './modules/plan-form';
import Plan from './modules/plan';
import Accordion from './modules/accordion';
import ImageMap from './modules/image-map';
import WooCommerce from './modules/woocommerce';
import './plugins/select';
import './plugins/contact-form';
import './plugins/retailer-form';
import './plugins/application-form';
import './plugins/breeder-form';
import './plugins/newsletter-form';
import '../../includes/mlmi-elements/plugins/scroll-events';
import '@fancyapps/fancybox';

$(function () {
  if ($.mlmi == undefined) {
    $.mlmi = {};
    $.mlmi.mobile = new Mobile();
  }

  /* App classes */
  $('body, head').attr('class', $('.app').data('view'));

  /* Prevent empty anchor clicks */
  $('a[href="#"]').on('click', function (e) {
    e.preventDefault();
  });

  /* Mouseenter dropdown menu */
  $('.menu-primary__item--parent > .menu-primary__link')
    .on('mousedown', function (e) {
      let isFirstTouch = !parseFloat($(this).parent().find('.menu-primary__sub-menu').css('opacity'));
      if (isFirstTouch) {
        $(this).data('prevented', true);
      } else {
        $(this).data('prevented', false);
      }
    })
    .on('click', function () {
      if ($(this).data('prevented')) {
        return false;
      }
    });

  /* Burger */
  let scrollTopBefore = 0,
    windowHeight = window.innerHeight,
    burgerTimeout = undefined;
  const burger = new Burger('.burger', {
    onToggle: function () {
      clearTimeout(burgerTimeout);
      if (burger.isExpanded) {
        $('body').addClass('--menu-open');
        windowHeight = window.innerHeight;
        burgerTimeout = setTimeout(function () {
          scrollTopBefore = $(window).scrollTop();
          $('.app').css({
            height: windowHeight + 'px',
            overflow: 'hidden'
          });
        }, 350);
      } else {
        $('.app').css({
          height: '',
          overflow: ''
        });
        $('body, html').removeClass('--menu-open').scrollTop(scrollTopBefore);
      }
    }
  });

  /* Mobile callbacks */
  $.mlmi.mobile.addCallbacks(
    function () {
      // desktop (none)
    },
    function () {
      // mobile
      $('body, html').removeClass('--menu-open');
      $('.app').css({
        height: '',
        overflow: ''
      });
    }
  );

  /* Tabs */
  Tabs.init();

  /* Forms */
  setTimeout(() => {
    Forms.init();
  }, 300);

  /* Carousels */
  Carousel.init();

  /* Locator */
  Locator.init();

  /* Filters */
  Filters.init();

  /* Cart */
  setTimeout(() => {
    Cart.init();
  }, 300);

  /* Plan form */
  PlanForm.init();

  /* Plan account */
  Plan.init();

  /* Accordion */
  Accordion.init();

  /* Image map */
  ImageMap.init();

  /* WooCommerce */
  WooCommerce.init();

  /* Province popup */
  ProvincePopup.init();

  /* Select elements */
  $('select.select, .variations select').each(function () {
    $(this).SelectElement();
  });

  /* Form greetings */
  $('.form-greeting').removeClass('form-greeting--visible');

  /* Mobile header */
  if ($('body.site-faimmuseau').length) {
    function checkHeader() {
      if ($.mlmi.mobile.isMobile) {
        $('.header').css('margin-top', $('.top-bar').outerHeight(false) + 'px');
        $('.header-nav__menu, .cart-panel__content').css('padding-top', $('.top-bar').outerHeight(false) + 'px');
        $('main').css('margin-top', $('.top-bar').outerHeight(false) + 'px');
      } else {
        $('.header').css('margin-top', '');
        $('.header-nav__menu, .cart-panel__content').css('padding-top', '');
        $('main').css('margin-top', '');
      }
    }
    if ($('.top-bar').length) {
      $(window).on('load resize orientationchange', checkHeader);
      checkHeader();
    }
  } else {
    let scrollEvents = $(window).ScrollEvents();
    scrollEvents.add(function (top) {
      if (!$.mlmi.mobile.isMobile && top > 200) {
        if (!$('body').hasClass('--menu-fixed')) {
          $('body').addClass('--menu-fixed');
          requestAnimationFrame(function () {
            $('body').addClass('--menu-appear');
          });
        }
      } else {
        $('body').removeClass('--menu-fixed --menu-appear');
      }
    });
  }

  /* Facebook Events */
  if ('fbq' in window) {
    $('.product-document').on('click', function () {
      fbq('track', 'Lead');
    });
  }

  /* MLMI forms */
  $('.newsletter-form').each(function () {
    $(this).NewsletterForm();
  });
  $('.contact-form').each(function () {
    $(this).ContactForm();
  });
  $('.retailer-form').each(function () {
    $(this).RetailerForm();
  });
  $('.breeder-form').each(function () {
    $(this).BreederForm();
  });
  $('.application-form').each(function () {
    $(this).ApplicationForm();
  });

  $('.js-apply-job').on('click', function () {
    var job_offer_id = $(this).attr('data-job-offer-id');
    $('.application-form').find('input[name="post_id"]').attr('value', job_offer_id);
  });

  /* Pie Chart */
  $('.pie-chart').each(function () {
    $(this).addClass('pie-chart--count-' + $(this).find('.pie-chart__item__label').length);
  });
});
